document.addEventListener("DOMContentLoaded", () => {

    const card = document.querySelector(".pruuvo-ai__card");
    const prompt = document.querySelector(".prompt");
    const input = document.querySelector(".chat-box input");
    const send = document.querySelector(".chat-box button");
    const close = document.querySelector(".pruuvo-ai__close");

    if(card){

        card.addEventListener("mousemove",(e)=>{

            const rect = card.getBoundingClientRect();

            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            card.style.background =
                `radial-gradient(circle at ${x}px ${y}px,
                rgba(255,145,0,.08),
                #ffffff 45%)`;

        });

        card.addEventListener("mouseleave",()=>{

            card.style.background="#fff";

        });

    }

    if(prompt){

        prompt.addEventListener("click",()=>{

            input.value = prompt.innerText;

            input.focus();

        });

    }

    if(send){

        send.addEventListener("click",()=>{

            if(input.value.trim() === "") return;

            send.innerHTML="✓";

            send.style.background="#22c55e";

            setTimeout(()=>{

                send.innerHTML="↑";

                send.style.background="#ff7d00";

                input.value="";

            },1200);

        });

    }

    if(input){

        input.addEventListener("keypress",(e)=>{

            if(e.key==="Enter"){

                send.click();

            }

        });

    }

    if(close){

        close.addEventListener("click",()=>{

            card.style.display="none";

        });

    }

});